import {
  GoabPageBlock,
  GoabSpacer,
  GoabButtonGroup,
  GoabButton,
  GoabCallout
} from "@abgov/react-components";
import DisplayContent from "../../../MPP-Common-SPA/components/DynamicForm/Forms/DisplayContent";
import { useLogin } from "../../hooks/useLogin";
import { getLoggedOutEndpoint } from "../../../ServiceUtils/auth";

const ApplicationUpdatedConfirmation = ({
  getResourceValue,
  uniqueApplicationCode,
  userApplicationData,
}) => {

  const { handleLogout } = useLogin();

  const url = getResourceValue({ key: "RESOURCES@url.alberta_supports" });

  return (
    <GoabPageBlock width="704px">
      <GoabSpacer vSpacing="3xl" />
      <GoabCallout type="success" size="medium">
        {getResourceValue({ key: "RESOURCES@applicationUpdated.callout" })}
      </GoabCallout>
      <h1>
        {getResourceValue({ key: "RESOURCES@applicationUpdated.header" })}
      </h1>
      <GoabSpacer vSpacing="xl" />
      <DisplayContent
        content={getResourceValue({ key: "RESOURCES@applicationUpdated.description", params: { url } })}
      ></DisplayContent>
      <GoabSpacer vSpacing="2xl" />
      <GoabButtonGroup alignment="start">
        <GoabButton
          type="primary"
          onClick={() => {
            document.location.href = `/application?code=${uniqueApplicationCode}`;
          }}
          testId="application-updated-view-application-button"
        >
          {getResourceValue({ key: "RESOURCES@button.manageApplication" })}
        </GoabButton>
        <GoabButton type="tertiary" trailingIcon="open" onClick={() => handleLogout(getLoggedOutEndpoint())}>
          {getResourceValue({ key: "RESOURCES@global.button.signout" })}
        </GoabButton>
      </GoabButtonGroup>
    </GoabPageBlock>
  );
};

export default ApplicationUpdatedConfirmation;
